import { GetServerSideProps, NextPage } from 'next'

import {
	getArticlePageProps,
	getListingPageProps
} from '~/components/pages/api'
import { ArticlePage, ErrorPage, ListingPage } from '~/components/pages'
import { ListPageType } from '~/types/app'
import {
	ArticlePageProps,
	ErrorPageProps,
	ListingPageProps
} from '~/types/page'
import { getParamAsString } from '~/util'

//----- Page Template Selector -----//

const PageTemplate: NextPage<
	ArticlePageProps | ErrorPageProps | ListingPageProps
> = (props) => {
	if ('errorStatus' in props) return <ErrorPage {...props} />
	if ('listType' in props) return <ListingPage {...props} />
	return <ArticlePage {...props} />
}

export default PageTemplate

//----- Page Props Selector -----//

export const getServerSideProps: GetServerSideProps = (ctx) => {
	const slug = getParamAsString(ctx.params?.slug, '1')

	// If the parameter is not a number, assume this is an article page
	return isNaN(Number(slug))
		? getArticlePageProps({ ...ctx, params: { ...ctx.params, slug } })
		: getListingPageProps({
				...ctx,
				params: {
					...ctx.params,
					listFile: '/the-sciences/[[...slug]]',
					listRoot: '',
					listType: ListPageType.CATEGORY,
					page: slug,
					slug: 'the-sciences'
				}
		  })
}
